import "./sidebar.scss";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Dashboard from "@mui/icons-material/Dashboard";
import SchoolIcon from "@mui/icons-material/School";
import FeedIcon from "@mui/icons-material/Feed";
import PeopleIcon from "@mui/icons-material/People";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AddchartIcon from "@mui/icons-material/Addchart";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import HistoryIcon from "@mui/icons-material/History";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DnsIcon from "@mui/icons-material/Dns";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ContactsIcon from "@mui/icons-material/Contacts";
import LockIcon from "@mui/icons-material/Lock";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentsIcon from "@mui/icons-material/Payments";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SettingsIcon from "@mui/icons-material/Settings";
import { useEffect, useMemo, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { hasSubscriptionFeature } from "../../config/subscriptionConfig";
import Tooltip from "@mui/material/Tooltip";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CommuteIcon from "@mui/icons-material/Commute";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import { hasPermission } from "../../utils/permissions";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import MessageIcon from "@mui/icons-material/Message";
import NotificationsNoneOutlined from "@mui/icons-material/NotificationsNoneOutlined";
import PowerSettingsNew from "@mui/icons-material/PowerSettingsNew";
import { logoutUser } from "../../services/authService";
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import TextsmsIcon from '@mui/icons-material/Textsms';

const fallbackMenu = [
  {
    icon: <Dashboard className="icon" />,
    label: "Workspace",
    path: "/workspace",
  },
];

export const menuConfig = {
  appOwner: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/owner",
    },
    {
      icon: <SchoolIcon className="icon" />,
      label: "Schools",
      path: "/schools",
    },
    {
      icon: <CreditCardIcon className="icon" />,
      label: "Billing",
      path: "/billing",
    },
    {
      icon: <PhotoLibraryIcon className="icon" />,
      label: "Media Gallery",
      path: "/gallery",
    },
    {
      icon: <FeedIcon className="icon" />,
      label: "Templates",
      path: "/templates",
    },
    {
      icon: <PeopleIcon className="icon" />,
      label: "Users",
      path: "/users",
    },
    {
      icon: <TextsmsIcon className="icon" />,
      label: "Enquiries",
      path: "/enquiries",
    },
  ],
  admin: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/admin",
    },

    {
      icon: <PeopleIcon className="icon" />,
      label: "Staffs",
      path: "/staffs",
      requiredPermission: "staffsView",
    },
    {
      icon: <SwitchAccountIcon className="icon" />,
      label: "Students",
      path: "/students",
      requiredAnyPermission: ["studentsView", "classStudentsView"],
    },
    {
      icon: <AccountBalanceWalletIcon className="icon" />,
      label: "Fee Records",
      path: "/fee-records",
      requiredFeature: "allowFeeRecords",
      requiredPlan: "Standard",
      requiredAnyPermission: ["feeRecord", "classFeeRecord"],
    },
    {
      icon: <ReceiptIcon className="icon" />,
      label: "Receipts",
      path: "/receipts",
      requiredFeature: "allowFeeRecords",
      requiredPlan: "Standard",
      requiredPermission: "feeReceiptView",
    },
    {
      icon: <AssignmentIcon className="icon" />,
      label: "Attendance",
      children: [
        {
          label: "Staff Attendance",
          path: "/staff-attendance",
          requiredPermission: "staffAttendanceMark",
        },
        {
          label: "Student Attendance",
          path: "/student-attendance",
          requiredAnyPermission: [
            "studentAttendanceMark",
            "classStudentAttendanceMark",
          ],
        },
        {
          label: "Staff Report",
          path: "/staff-attendance-report",
          requiredFeature: "allowStaffAttendanceReport",
          requiredPlan: "Standard",
          requiredPermission: "staffAttendanceReportView",
        },
        {
          label: "Student Report",
          path: "/student-attendance-report",
          requiredFeature: "allowStudentAttendanceReport",
          requiredPlan: "Standard",
          requiredPermission: "studentAttendanceReportView",
          requiredAnyPermission: [
            "studentAttendanceReportView",
            "classStudentAttendanceReportView",
          ],
        },
      ],
    },
    {
      icon: <CalendarMonthIcon className="icon" />,
      label: "Time Table",
      path: "/timetable",
      requiredPermission: "timetableManage",
    },
    {
      icon: <LocalLibraryIcon className="icon" />,
      label: "Library",
      path: "/library",
      requiredFeature: "allowLibrary",
      requiredPlan: "Premium",
    },
    {
      icon: <CommuteIcon className="icon" />,
      label: "Transport",
      path: "/transport",
      requiredFeature: "allowTransport",
      requiredPlan: "Premium",
    },
    {
      icon: <PaymentsIcon className="icon" />,
      label: "Payrolls",
      children: [
        {
          label: "Monthly Payroll",
          path: "/accounts",
          requiredFeature: "allowPayroll",
          requiredPlan: "Standard",
        },
        {
          label: "Account Statement",
          path: "/account-statement",
          requiredFeature: "allowPayroll",
          requiredPlan: "Standard",
        },
      ],
    },

    {
      icon: <AddchartIcon className="icon" />,
      label: "Upload Scores",
      children: [
        {
          label: "Upload Marks",
          path: "/upload-marks",
          requiredAnyPermission: ["scoreUpload", "classScoreUpload"],
        },
        {
          label: "Upload Grades",
          path: "/upload-grades",
          requiredAnyPermission: ["scoreUpload", "classScoreUpload"],
        },
      ],
    },
    {
      icon: <FileOpenIcon className="icon" />,
      label: "Export Docs",
      children: [
        {
          label: "Staff documents",
          path: "/staffs/export-docs",
          requiredPlan: "Standard",
          requiredPermission: "staffDocsExport",
        },
        {
          label: "Student documents",
          path: "/students/export-docs",
          requiredPermission: "studentDocsExport",
        },
      ],
    },
    {
      icon: <HistoryIcon className="icon" />,
      label: "Docs History",
      children: [
        {
          label: "Staff docs history",
          path: "/docs-history/staffs",
          requiredPermission: "staffDocsExport",
        },
        {
          label: "Student docs history",
          path: "/docs-history/students",
          requiredPermission: "studentDocsExport",
        },
      ],
    },
    {
      icon: <AutoGraphIcon className="icon" />,
      label: "Progression",
      path: "/progression",
      requiredFeature: "allowProgression",
      requiredPlan: "Basic",
      requiredPermission: "progressionManage",
    },
    {
      icon: <ManageAccountsIcon className="icon" />,
      label: "Users",
      path: "/school/users",
      requiredFeature: "allowSchoolUsers",
      requiredPlan: "Standard",
      requiredPermission: "usersView",
    },
  ],
  teacher: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/teacher",
    },
  ],
  receptionist: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/receptionist",
    },
  ],
  parent: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/parent",
    },
  ],
  student: [
    {
      icon: <Dashboard className="icon" />,
      label: "Dashboard",
      path: "/student",
    },
  ],
  principal: fallbackMenu,
  manager: fallbackMenu,
  coordinator: fallbackMenu,
  operator: fallbackMenu,
};

export const getMenuItemsForUser = (currentUser) => {
  const roleMenu = menuConfig[currentUser?.role] || [];
  if (
    ![
      "manager",
      "principal",
      "teacher",
      "receptionist",
      "coordinator",
      "operator",
    ].includes(currentUser?.role)
  ) {
    return roleMenu;
  }

  const allowed = (item) => {
    const permission = item.requiredAnyPermission || item.requiredPermission;
    return Boolean(permission) && hasPermission(currentUser, permission);
  };
  const permissionMenu = menuConfig.admin
    .map((item) => {
      if (!item.children) return allowed(item) ? item : null;
      const children = item.children.filter(allowed);
      return children.length ? { ...item, children } : null;
    })
    .filter(Boolean);
  const baseMenu = roleMenu
    .map((item) => {
      if (item.path === `/${currentUser.role}` || item.path === "/workspace")
        return item;
      if (!item.children) return allowed(item) ? item : null;
      const children = item.children.filter(allowed);
      return children.length ? { ...item, children } : null;
    })
    .filter(Boolean);
  const basePaths = new Set(baseMenu.map(({ path }) => path).filter(Boolean));
  const permissionActionGroups = [
    {
      label: "Quick Actions",
      icon: <AutoFixHighIcon className="icon" />,
      actions: [
        {
          label: "Add Student",
          path: "/students/new",
          requiredAnyPermission: ["studentCreate", "classStudentCreate"],
        },
        {
          label: "Add Staff",
          path: "/staffs/new",
          requiredPermission: "staffCreate",
        },
        {
          label: "Import Students",
          path: "/import-students",
          requiredPermission: "studentImport",
        },
        {
          label: "Import Staffs",
          path: "/import-staffs",
          requiredPermission: "staffImport",
        },
      ],
    },
  ];
  const directPermissionItems = permissionActionGroups
    .map((group) => {
      const children = group.actions.filter(allowed);
      return children.length
        ? { icon: group.icon, label: group.label, children }
        : null;
    })
    .filter(Boolean);
  return [
    ...baseMenu,
    ...directPermissionItems,
    ...permissionMenu.filter((item) => !basePaths.has(item.path)),
  ];
};

const Sidebar = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentSchool } = useSelector((state) => state.school);
  const { darkMode } = useSelector((state) => state.theme);
  const location = useLocation();

  const dispatch = useDispatch();

  const menuItems = useMemo(
    () => getMenuItemsForUser(currentUser),
    [currentUser],
  );

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  useEffect(() => {
    // auto-open dropdown if current path belongs to its children
    menuItems.forEach((item) => {
      if (
        item.children?.some((child) => location.pathname.startsWith(child.path))
      ) {
        setOpenDropdown(item.label);
      }
    });
  }, [location.pathname, menuItems]);

  // Helper function to check if a path is active
  const isActive = (path) => {
    if (location.pathname === path) return true;
    // For paths with dynamic segments like /classes/:classId, check if pathname starts with base path
    if (path.includes(":")) {
      const basePath = path.split(":")[0].slice(0, -1); // Remove trailing slash
      return location.pathname.startsWith(basePath);
    }
    return false;
  };

  return (
    <div className="sidebar">
      <div className="sidebarTop">
        <Link to="/" className="menuLink">
          <div className="top">
            {/* Big logo (desktop + mobile open) */}
            <img
              className="brandImg big"
              src={
                darkMode
                  ? `${process.env.PUBLIC_URL}/images/logo-white.png`
                  : `${process.env.PUBLIC_URL}/images/logo.png`
              }
              alt="Logo"
            />
            {/* Small logo (tablet collapsed) */}
            <img
              className="brandImg small"
              src={`${process.env.PUBLIC_URL}/images/logo-sm.png`}
              alt="Logo Small"
            />
          </div>
        </Link>
      </div>
      <div className="sidebarBottom">
        <div className="center">
          <ul>
            {menuItems.map((item) =>
              item.children ? (
                <li
                  key={item.label}
                  className="menuItem"
                  onClick={() => toggleDropdown(item.label)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                    className={`menuLink ${openDropdown === item.label ? "active" : ""}`}
                  >
                    <div className="iconLabel">
                      {item.icon}
                      <span>{item.label}</span>
                    </div>
                    <div className="arrow">
                      <ChevronRightIcon />
                    </div>
                  </div>
                  <ul
                    className={`submenu ${openDropdown === item.label ? "open" : ""}`}
                  >
                    {item.children.map((child) =>
                      (() => {
                        if (
                          !hasPermission(
                            currentUser,
                            child.requiredAnyPermission ||
                              child.requiredPermission,
                          )
                        )
                          return null;
                        const isLocked =
                          child.requiredFeature &&
                          !hasSubscriptionFeature(
                            currentSchool?.subscription?.featureTier,
                            child.requiredFeature,
                          );
                        const option = (
                          <li className={isLocked ? "locked" : ""}>
                            <span>{child.label}</span>
                            {isLocked && (
                              <LockIcon
                                className="featureLockIcon"
                                // fontSize="small"
                                sx={{ fontSize: 15, margin: "0 0 0 auto" }}
                                aria-label={`${child.label} requires ${child.requiredPlan} plan`}
                              />
                            )}
                          </li>
                        );

                        return isLocked ? (
                          <div
                            key={child.path}
                            className="submenuLink lockedLink"
                          >
                            <Tooltip
                              title={`This option is available on the ${child.requiredPlan} plan or higher.`}
                              placement="right"
                              arrow
                            >
                              {option}
                            </Tooltip>
                          </div>
                        ) : (
                          <Link
                            key={child.path}
                            to={child.path}
                            className={`submenuLink ${isActive(child.path) ? "active" : ""}`}
                          >
                            {option}
                          </Link>
                        );
                      })(),
                    )}
                  </ul>
                </li>
              ) : (
                (() => {
                  if (
                    !hasPermission(
                      currentUser,
                      item.requiredAnyPermission || item.requiredPermission,
                    )
                  )
                    return null;
                  const isLocked =
                    item.requiredFeature &&
                    !hasSubscriptionFeature(
                      currentSchool?.subscription?.featureTier,
                      item.requiredFeature,
                    );
                  const option = (
                    <li className={isLocked ? "locked" : ""}>
                      {item.icon}
                      <span>{item.label}</span>
                      {isLocked && (
                        <LockIcon
                          className="featureLockIcon"
                          sx={{ fontSize: 15, margin: "0 0 0 auto" }}
                          aria-label={`${item.label} requires ${item.requiredPlan} plan`}
                        />
                      )}
                    </li>
                  );

                  return isLocked ? (
                    <div key={item.path} className="menuLink lockedLink">
                      <Tooltip
                        title={`This option is available on the ${item.requiredPlan} plan or higher.`}
                        placement="right"
                        arrow
                      >
                        {option}
                      </Tooltip>
                    </div>
                  ) : (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`menuLink ${isActive(item.path) ? "active" : ""}`}
                    >
                      {option}
                    </Link>
                  );
                })()
              ),
            )}
          </ul>
          {currentUser?.role === "admin" && (
            <details>
              <summary>
                <span>Setup</span>
              </summary>
              <ul>
                <Link
                  className={`menuLink ${isActive("/sessions") ? "active" : ""}`}
                  to="/sessions"
                >
                  <li>
                    <FormatListBulletedIcon className="icon" />
                    <span>Sessions</span>
                  </li>
                </Link>
                <Link
                  className={`menuLink ${isActive("/classes") ? "active" : ""}`}
                  to="/classes"
                >
                  <li>
                    <DnsIcon className="icon" />
                    <span>Classes</span>
                  </li>
                </Link>
                <Link
                  className={`menuLink ${isActive("/subjects") ? "active" : ""}`}
                  to="/subjects"
                >
                  <li>
                    <MenuBookIcon className="icon" />
                    <span>Subjects</span>
                  </li>
                </Link>
                <Link
                  className={`menuLink ${isActive("/exams") ? "active" : ""}`}
                  to="/exams"
                >
                  <li>
                    <FactCheckIcon className="icon" />
                    <span>Exams</span>
                  </li>
                </Link>
                {hasSubscriptionFeature(
                  currentSchool?.subscription?.featureTier,
                  "allowFeeRecords",
                ) ? (
                  <Link
                    className={`menuLink ${
                      isActive("/fee-books") ? "active" : ""
                    }`}
                    to="/fee-books"
                  >
                    <li>
                      <LibraryBooksIcon className="icon" />
                      <span>Fee Books</span>
                    </li>
                  </Link>
                ) : (
                  <div className="menuLink lockedLink">
                    <Tooltip
                      title={`This option is available on the Standard plan or above only.`}
                      placement="right"
                      arrow
                    >
                      <li className="locked">
                        <LibraryBooksIcon className="icon" />
                        <span>Fee Books</span>
                        <LockIcon
                          className="featureLockIcon"
                          sx={{ fontSize: 15, margin: "0 0 0 auto" }}
                          aria-label={`Fee Books requires Standard plan`}
                        />
                      </li>
                    </Tooltip>
                  </div>
                )}

                <Link
                  className={`menuLink ${
                    isActive("/import-staffs") ? "active" : ""
                  }`}
                  to="/import-staffs"
                >
                  <li>
                    <GroupAddIcon className="icon" />
                    <span>Import Staffs</span>
                  </li>
                </Link>
                <Link
                  className={`menuLink ${
                    isActive("/import-students") ? "active" : ""
                  }`}
                  to="/import-students"
                >
                  <li>
                    <ContactsIcon className="icon" />
                    <span>Import Students</span>
                  </li>
                </Link>
              </ul>
            </details>
          )}
        </div>
        <div className="bottom">
          <ul>
            <Link
              to="/notifications"
              className={`menuLink ${isActive("/notifications") ? "active" : ""}`}
            >
              <li>
                <NotificationsNoneOutlined className="icon" />
                <span>Notifications</span>
              </li>
            </Link>
            <Link
              to="/messages"
              className={`menuLink ${isActive("/messages") ? "active" : ""}`}
            >
              <li>
                <MessageIcon className="icon" />
                <span>Messages</span>
              </li>
            </Link>
            <Link
              to="/settings"
              className={`menuLink ${isActive("/settings") ? "active" : ""}`}
            >
              <li>
                <SettingsIcon className="icon" />
                <span>Settings</span>
              </li>
            </Link>

            <li onClick={()=> logoutUser(dispatch)}>
              <PowerSettingsNew className="icon" />
              <span>Logout</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
